import { render, staticRenderFns } from "./CustomerAddressesList.vue?vue&type=template&id=5bf59666"
import script from "./CustomerAddressesList.vue?vue&type=script&lang=ts"
export * from "./CustomerAddressesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports